(function () {
  const LOG = '[PillSlider]';
  const ROOT_SELECTOR = '[data-product-pill-slider]';
  const instances = new Set();

  console.log(LOG, 'script loaded', { readyState: document.readyState });

  document.addEventListener('visibilitychange', () => {
    console.log(LOG, 'visibilitychange', { hidden: document.hidden, instanceCount: instances.size });
    instances.forEach((inst) => {
      if (!inst.root.isConnected) {
        console.log(LOG, 'removing disconnected instance');
        inst.stop();
        instances.delete(inst);
        return;
      }
      if (document.hidden) inst.stop();
      else inst.start();
    });
  });

  function parseIntervalMs(root) {
    const raw = root.getAttribute('data-interval-ms');
    const n = parseInt(String(raw ?? '').trim(), 10);
    if (Number.isFinite(n) && n > 0) return n;
    return 4000;
  }

  function initRoot(root, context) {
    console.log(LOG, 'initRoot', context, {
      element: root,
      alreadyReady: root.dataset.pillSliderReady === 'true',
    });

    if (root.dataset.pillSliderReady === 'true') {
      console.log(LOG, 'skip: already initialized');
      return;
    }

    const strip = root.querySelector('.product-pill-banner__slider-strip');
    const slides = root.querySelectorAll('.product-pill-banner__slide');
    console.log(LOG, 'DOM query', { hasStrip: !!strip, slideCount: slides.length });

    if (!strip || slides.length < 2) {
      console.warn(LOG, 'abort init: need strip and at least 2 slides', { hasStrip: !!strip, slideCount: slides.length });
      return;
    }

    root.dataset.pillSliderReady = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      console.log(LOG, 'abort init: prefers-reduced-motion is reduce (no autoplay)');
      return;
    }

    const intervalMs = parseIntervalMs(root);
    const slideList = Array.from(slides);
    let current = 0;
    let timer = null;

    const inst = {
      root,
      stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
          console.log(LOG, 'timer stopped');
        }
      },
      start() {
        if (document.hidden) {
          console.log(LOG, 'start() skipped: document.hidden');
          return;
        }
        inst.stop();
        timer = window.setInterval(tick, intervalMs);
        console.log(LOG, 'timer started', { intervalMs, slideCount: slideList.length });
      },
    };

    function setAria(active) {
      slideList.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
      });
    }

    function tick() {
      if (!root.isConnected) {
        console.warn(LOG, 'tick: root disconnected, cleaning up');
        inst.stop();
        instances.delete(inst);
        return;
      }
      current = (current + 1) % slideList.length;
      const n = slideList.length;
      const pct = (-100 / n) * current;
      strip.style.transform = 'translateX(' + pct + '%)';
      setAria(current);
      console.log(LOG, 'tick → slide', { current, pct: pct + '%', transform: strip.style.transform });
    }

    instances.add(inst);
    inst.start();
    console.log(LOG, 'instance registered', { totalInstances: instances.size });
  }

  function initAll(source) {
    const nodes = document.querySelectorAll(ROOT_SELECTOR);
    console.log(LOG, 'initAll', source, { matchCount: nodes.length, nodes: Array.from(nodes) });
    nodes.forEach((node, i) => initRoot(node, source + '[' + i + ']'));
  }

  if (document.readyState === 'loading') {
    console.log(LOG, 'waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', () => initAll('DOMContentLoaded'));
  } else {
    initAll('immediate');
  }

  document.addEventListener('shopify:section:load', (event) => {
    console.log(LOG, 'shopify:section:load', event.detail || event);
    initAll('shopify:section:load');
  });
})();
